import ButtonTsoPq from '@components/Buttons/ButtonTsoPq';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled } from '@mui/material';
import { t } from 'i18next';

const StyledLegendContainer = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'flex-end',
    alignSelf: 'stretch',
  };
});

const LegendTsoPq = () => {
  return (
    <StyledLegendContainer>
      <ButtonTsoPq
        textContent={t('info.legend')}
        buttonType="transparentPrimary"
        sizeVariant="m"
        iconRight={<FontAwesomeIcon icon={faCircleInfo} />}
        tooltip="legend"
        tooltipVariant="legend"
      />
    </StyledLegendContainer>
  );
};

export default LegendTsoPq;
